import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPerla = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10.7,
		cy: 13.32,
		r: 7,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.88 3.87C19.63 3.67 20.31 4.35 20.11 5.1L17.55 14.64L9.34 6.43L18.88 3.87Z",
		fill: "currentColor"
	})]
});
export default SvgIconPerla;
